// extracted by mini-css-extract-plugin
export default {"ncBadge":"NCBadge_ncBadge__d5JGC","sm":"NCBadge_sm__AW+4S","md":"NCBadge_md__SAQMm"};